import React, { useEffect, useRef, useState } from 'react';
import './styles/app.scss';
import { WidthContextProvider } from './WidthContext';
import Footer from './components/common-footer/Footer';
import Header from './components/common-header/Header';
import IsiModal from './components/ISI/IsiModal';
import Hero from './components/Hero/Hero';
import IsiBody from './components/ISI/IsiBody';
import Chapters from './components/Chapters/Chapters';
import Resources from './components/Resources/Resources';
import Footnotes from './components/Footnotes/Footnotes';
import IsiSticky from './components/ISI/IsiSticky';

function App() {
  const modalRef = useRef();
  const headerRef = useRef();
  const stickyRef = useRef();
  const isiBottomRef = useRef();
  const [isOpen, setIsOpen] = useState(false);
  useEffect(() => {
    if (isOpen) {
      if (modalRef.current) {
        modalRef.current.style.opacity = '1';
      }
    } else {
      if (modalRef.current) {
        modalRef.current.style.opacity = '0';
      }
    }
  }, [isOpen]);
  useEffect(() => {
    const observer = new IntersectionObserver(
      function (entries) {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            stickyRef.current.style.position = 'relative';
          } else {
            stickyRef.current.style.position = 'fixed';
            stickyRef.current.style.top = '0';
          }
        });
      },
      { threshold: [0] }
    );
    observer.observe(headerRef.current);
  }, []);

  useEffect(() => {
    const observer = new IntersectionObserver(
      function (entries) {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            stickyRef.current.style.top = '-500px';
          } else {
            stickyRef.current.style.top = '0';
          }
        });
      },
      { threshold: [0] }
    );
    observer.observe(isiBottomRef.current);
  }, []);
  return (
    <WidthContextProvider>
      <main className="App">
        <Header clientName={'Johnson & Johnson'} headerRef={headerRef} />
        <section className="App__sticky">
          <div className="App__sticky__isi">
            <IsiSticky isOpen={isOpen} setIsOpen={setIsOpen} stickyRef={stickyRef} />
          </div>
          {isOpen && <IsiModal modalRef={modalRef} isOpen={isOpen} setIsOpen={setIsOpen} />}
          <Hero />
          <Chapters />
          <Resources />
        </section>
        <div className="chapters__chapter" id="isi" ref={isiBottomRef}>
          <IsiBody origin={'bottom'} />
        </div>
        <Footnotes />
        <p className="isi__body__text App__bottom">cp-447066v1</p>
        <Footer />
      </main>
    </WidthContextProvider>
  );
}

export default App;
